export const cibGlassdoor = ["32 32","<path d='M22.859 27.427h-18.286c0 2.526 2.047 4.573 4.568 4.573h13.714c2.526 0 4.573-2.047 4.573-4.573v-18.771c0-0.094-0.073-0.167-0.167-0.167h-4.24c-0.089 0-0.161 0.073-0.161 0.167v18.776zM22.859 0c2.521 0 4.568 2.047 4.568 4.573h-18.281v18.771c0 0.089-0.078 0.167-0.167 0.167h-4.24c-0.094 0-0.167-0.078-0.167-0.167v-18.771c0-2.526 2.047-4.573 4.568-4.573h13.719z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-glassdoor.js
// module id = null
// module chunks = 